export default __webpack_public_path__ + "static/media/popular-background.47d1d6be.png";